import React, { useEffect } from 'react';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import { connect } from 'unistore/full/react';
import actions from './actions';
import Content from './Content';
import CreatePlaylistRow from './CreatePlaylistRow';
import LikedSongsRow from './LikedSongsRow';
import PlaylistRow from './PlaylistRow';
import './YourLibrary.scss';
import YourLibraryTabs from './YourLibraryTabs';

export default connect(
  ['playlists', 'stations', 'playlistsById'],
  actions
)(function YourLibrary(props) {
  const history = useHistory();
  const activeSectionType = useRouteMatch()?.params?.section || 'playlists';

  useEffect(() => {
    props.fetchRootlist();
  }, []);

  useEffect(() => {
    if (activeSectionType === 'playlists') props.fetchRootlist();
  }, [activeSectionType]);

  const { playlists: realPlaylists, stations, playlistsById } = props;
  const playlists = [
    ...Object.entries(playlistsById)
      .filter(([_, { seeds, isFollowing } = {}]) => !!seeds && !isFollowing)
      .reverse()
      .map(([key, { id, name, imageUrl, ownerDisplayName, seeds } = {}]) => ({
        id,
        name,
        owner: { display_name: ownerDisplayName },
        images: [{ url: imageUrl }],
        isDynamic: seeds?.length,
      })),
    ...(realPlaylists || []),
  ];
  return (
    <Content>
      <div className="YourLibrary">
        <div className="YourLibrary__log-out-button" onClick={props.logout}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
          >
            <path
              fill="#fff"
              d="M14.354 2.353l-.708-.707L8 7.293 2.353 1.646l-.707.707L7.293 8l-5.647 5.646.707.708L8 8.707l5.646 5.647.708-.708L8.707 8l5.647-5.647z"
            ></path>
          </svg>
        </div>

        <YourLibraryTabs />

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="375"
          height="44"
          fill="none"
          viewBox="0 0 375 44"
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            background: '#121212',
          }}
        >
          <g onClick={() => history.replace('/playlists')}>
            <text
              fill="#fff"
              style={{
                whiteSpace: 'pre',
                willChange: 'opacity',
                transition: 'opacity 0.2s ease-in-out',
                opacity: activeSectionType === 'playlists' ? 1 : 0.46,
              }}
              fontSize="16"
              fontWeight="bold"
              letterSpacing="0em"
            >
              <tspan x="16" y="27.24">
                Playlists
              </tspan>
            </text>
          </g>

          {/* <g onClick={() => history.replace('/stations')}>
            <text
              fill="#fff"
              style={{
                whiteSpace: 'pre',
                willChange: 'opacity',
                transition: 'opacity 0.2s ease-in-out',
                opacity: activeSectionType === 'stations' ? 1 : 0.46,
              }}
              fontSize="16"
              fontWeight="bold"
              letterSpacing="0em"
            >
              <tspan x="101" y="27.24">
                Stations
              </tspan>
            </text>
          </g> */}

          <g transform="translate(-84, 0)">
            <text
              fill="#7F7F7F"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="bold"
              letterSpacing="0em"
            >
              <tspan x="185" y="27.24">
                Artists
              </tspan>
            </text>

            <text
              fill="#7F7F7F"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="bold"
              letterSpacing="0em"
            >
              <tspan x="258" y="27.24">
                Albums
              </tspan>
            </text>
          </g>

          <g transform="translate(0, 42)">
            <g
              style={{
                transformOrigin: 'center left',
                transform: {
                  playlists: `translate3d(16px, 0, 0) scaleX(0.61)`,
                  stations: `translate3d(101px, 0, 0) scaleX(0.61)`,
                }[activeSectionType],
                willChange: 'transform',
                transition: 'transform 0.2s',
              }}
            >
              <rect width="100" height="2" fill="#1DB954" />
            </g>
          </g>
        </svg>

        {realPlaylists?.length === 0 ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 375 128"
            style={{
              marginTop: '116px',
            }}
            onClick={() => history.push('/new/playlist')}
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="24"
              fontWeight="bold"
              letterSpacing="-0.96"
            >
              <tspan x="64.934" y="21.86">
                Create your first playlist
              </tspan>
            </text>
            <rect
              width="231"
              height="48"
              x="72"
              y="80"
              fill="#fff"
              rx="24"
            ></rect>
            <text
              fill="#121212"
              style={{ whiteSpace: 'pre' }}
              fontSize="14"
              fontWeight="bold"
              letterSpacing="1.4"
            >
              <tspan x="157.726" y="108.585">
                CREATE
              </tspan>
            </text>
            <text
              fill="#B3B3B3"
              style={{ whiteSpace: 'pre' }}
              fontSize="13"
              fontWeight="450"
              letterSpacing="0"
            >
              <tspan x="118" y="50.258">
                It’s easy, we’ll help you.
              </tspan>
            </text>
          </svg>
        ) : (
          <>
            <CreatePlaylistRow />
            <LikedSongsRow />
            {playlists?.map(
              ({
                id,
                name,
                owner: { display_name: displayName } = {},
                images: [{ url: imageUrl } = {}] = [],
                isDynamic,
              }) => (
                <Link
                  to={`/${isDynamic ? 'dynamic-playlist' : 'playlist'}/${id}`}
                  key={id}
                >
                  <PlaylistRow
                    title={name}
                    meta={`by ${displayName}`}
                    imageUrl={imageUrl}
                  />
                </Link>
              )
            )}
          </>
        )}
      </div>
    </Content>
  );
});
